import React, { useState } from "react";
import AppShell from "@/components/AppShell";
import { useAuth } from "@/context/AuthContext";
import { api, errorMessage } from "@/lib/api";

export default function ProfilePage() {
  const { user, setUser } = useAuth();
  const [form, setForm] = useState({
    full_name: user?.full_name || "",
    mobile: user?.mobile || "",
    organization: user?.organization || "",
  });
  const [pw, setPw] = useState({ current_password: "", new_password: "" });
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");

  const saveProfile = async (e) => {
    e.preventDefault();
    setMsg(""); setError("");
    try {
      const { data } = await api.put("/me/profile", form);
      setUser(data);
      setMsg("Profile updated.");
    } catch (err) { setError(errorMessage(err)); }
  };

  const changePw = async (e) => {
    e.preventDefault();
    setMsg(""); setError("");
    try {
      await api.post("/auth/change-password", pw);
      setMsg("Password updated.");
      setPw({ current_password: "", new_password: "" });
    } catch (err) { setError(errorMessage(err)); }
  };

  return (
    <AppShell section="user">
      <div className="p-6 lg:p-10 max-w-3xl">
        <div className="overline mb-3">Account</div>
        <h1 className="font-display font-black text-3xl lg:text-4xl tracking-tight mb-8">Profile & security</h1>

        {msg && <div className="mb-5 p-3 border border-primary/30 bg-primary/5 text-primary text-[13px]">{msg}</div>}
        {error && <div className="mb-5 p-3 border border-destructive/30 bg-destructive/5 text-destructive text-[13px]">{error}</div>}

        <form onSubmit={saveProfile} className="border border-border bg-white p-6 lg:p-8 mb-8">
          <h2 className="font-display font-bold text-lg mb-5">Personal information</h2>
          <div className="space-y-4">
            <div>
              <label className="block text-[12px] font-semibold uppercase tracking-wider text-muted-foreground mb-1.5">Full name</label>
              <input data-testid="profile-name-input" value={form.full_name} onChange={(e) => setForm({ ...form, full_name: e.target.value })}
                className="w-full h-11 px-3 border border-border bg-white focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary" />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-[12px] font-semibold uppercase tracking-wider text-muted-foreground mb-1.5">Mobile</label>
                <input data-testid="profile-mobile-input" value={form.mobile} onChange={(e) => setForm({ ...form, mobile: e.target.value })}
                  className="w-full h-11 px-3 border border-border bg-white focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary" />
              </div>
              <div>
                <label className="block text-[12px] font-semibold uppercase tracking-wider text-muted-foreground mb-1.5">Organization</label>
                <input data-testid="profile-org-input" value={form.organization} onChange={(e) => setForm({ ...form, organization: e.target.value })}
                  className="w-full h-11 px-3 border border-border bg-white focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary" />
              </div>
            </div>
            <div>
              <label className="block text-[12px] font-semibold uppercase tracking-wider text-muted-foreground mb-1.5">Email</label>
              <input value={user?.email || ""} disabled className="w-full h-11 px-3 border border-border bg-accent text-muted-foreground" />
            </div>
          </div>
          <button data-testid="profile-save-button" className="mt-6 h-11 px-6 bg-primary text-primary-foreground font-semibold text-[13px] hover:bg-[#001d6b]">Save changes</button>
        </form>

        {user?.auth_provider !== "google" && (
          <form onSubmit={changePw} className="border border-border bg-white p-6 lg:p-8">
            <h2 className="font-display font-bold text-lg mb-5">Change password</h2>
            <div className="space-y-4">
              <div>
                <label className="block text-[12px] font-semibold uppercase tracking-wider text-muted-foreground mb-1.5">Current password</label>
                <input data-testid="current-pw-input" type="password" required value={pw.current_password} onChange={(e) => setPw({ ...pw, current_password: e.target.value })}
                  className="w-full h-11 px-3 border border-border bg-white focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary" />
              </div>
              <div>
                <label className="block text-[12px] font-semibold uppercase tracking-wider text-muted-foreground mb-1.5">New password</label>
                <input data-testid="new-pw-input" type="password" minLength={6} required value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })}
                  className="w-full h-11 px-3 border border-border bg-white focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary" />
              </div>
            </div>
            <button data-testid="change-pw-button" className="mt-6 h-11 px-6 bg-primary text-primary-foreground font-semibold text-[13px] hover:bg-[#001d6b]">Update password</button>
          </form>
        )}
      </div>
    </AppShell>
  );
}
